
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import Credits from "@/components/Credits";
import CreditHistory from "@/components/CreditHistory";

interface CreditManagementProps {
  credits: number;
  transactions: Array<{
    id: string;
    type: 'purchase' | 'usage';
    amount: number;
    description: string;
    date: string;
  }>;
  onPurchase: (amount: number) => void;
}

const CreditManagement = ({ credits, transactions, onPurchase }: CreditManagementProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      <div className="md:col-span-1">
        <Card>
          <CardHeader>
            <CardTitle>Credit Management</CardTitle>
            <CardDescription>Purchase and manage your credits</CardDescription>
          </CardHeader>
          <CardContent>
            <Credits credits={credits} onPurchase={onPurchase} />
          </CardContent>
        </Card>
      </div>
      <div className="md:col-span-2">
        <CreditHistory transactions={transactions} />
      </div>
    </div>
  );
};

export default CreditManagement;
